import React from 'react';
import classnames from 'classnames';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import ErrorBoundary from '../ErrorBoundary';
import LazyContext from '../LazyLoadingImage/LazyContext';
import SidebarBlock from './SidebarBlock';
import LoaderBlock from './_partials/LoaderBlock';
import s from './Sidebar.scss';
var Sidebar = function (_a) {
    var _b;
    var deviation = _a.deviation, className = _a.className;
    var isUpdatedSidebarStylesFlagEnabled = useFlag('updated_sidebar_styles');
    var blocks = (_b = deviation === null || deviation === void 0 ? void 0 : deviation.extended) === null || _b === void 0 ? void 0 : _b.relatedContent;
    var isLoading = !deviation.extended;
    return (React.createElement(ErrorBoundary, { debugComponent: "Sidebar" },
        React.createElement(LazyContext.Provider, { value: true },
            React.createElement("div", { className: classnames(s['root'], isUpdatedSidebarStylesFlagEnabled && s['updated_sidebar_styles'], className), role: "complementary" },
                !isLoading &&
                    blocks &&
                    blocks.map(function (block) { return (React.createElement(BiLoggerContextProvider, { key: block.contentType, value: { _rankOffset: 0 } },
                        React.createElement(SidebarBlock, { block: block, deviation: deviation }))); }),
                isLoading && (React.createElement(React.Fragment, null,
                    React.createElement(LoaderBlock, { index: 0 }),
                    React.createElement(LoaderBlock, { index: 1 }),
                    React.createElement(LoaderBlock, { index: 2 })))))));
};
Sidebar.displayName = 'Sidebar';
export default Sidebar;
//# sourceMappingURL=Sidebar.js.map